import { createContext } from "react";

export const LocaleApplied = createContext<boolean>(false);
